module.exports = __webpack_public_path__ + "img/iraq.31884031.svg";